/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Overview_Agerating2Inputs */

const id_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peringkat Usia`)
};

const ms_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penarafan Umur`)
};

const da_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aldersvurdering`)
};

const de_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altersfreigabe`)
};

const en_us2_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Age Rating`)
};

const es_es2_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificación por edad`)
};

const es_mx2_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificación por edad`)
};

const fil_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rating ng Edad`)
};

const fr_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classification`)
};

const it_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificazione età`)
};

const hu_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korhatár besorolás`)
};

const nl_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leeftijdsclassificatie`)
};

const no_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aldersvurdering`)
};

const pl_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasyfikacja wiekowa`)
};

const pt_br2_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação etária`)
};

const pt_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação etária`)
};

const ro_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificare de vârstă`)
};

const fi_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikäraja`)
};

const sv_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Åldersklassificering`)
};

const vi_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xếp hạng độ tuổi`)
};

const tr_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaş Sınırı`)
};

const cs_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Věkové hodnocení`)
};

const bg_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Възрастово ограничение`)
};

const ru_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Возрастной рейтинг`)
};

const uk_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Віковий рейтинг`)
};

const ar_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التصنيف العمري`)
};

const hi_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयु रेटिंग`)
};

const th_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรตอายุ`)
};

const ja_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年齢レーティング`)
};

const zh_cn2_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年龄分级`)
};

const zh_hant1_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年齡分級`)
};

const ko_offerdetail_overview_agerating2 = /** @type {(inputs: Offerdetail_Overview_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연령 등급`)
};

/**
* | output |
* | --- |
* | "Age Rating" |
*
* @param {Offerdetail_Overview_Agerating2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_overview_agerating2 = /** @type {((inputs?: Offerdetail_Overview_Agerating2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Overview_Agerating2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_overview_agerating2(inputs)
	if (locale === "ms") return ms_offerdetail_overview_agerating2(inputs)
	if (locale === "da") return da_offerdetail_overview_agerating2(inputs)
	if (locale === "de") return de_offerdetail_overview_agerating2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_overview_agerating2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_overview_agerating2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_overview_agerating2(inputs)
	if (locale === "fil") return fil_offerdetail_overview_agerating2(inputs)
	if (locale === "fr") return fr_offerdetail_overview_agerating2(inputs)
	if (locale === "it") return it_offerdetail_overview_agerating2(inputs)
	if (locale === "hu") return hu_offerdetail_overview_agerating2(inputs)
	if (locale === "nl") return nl_offerdetail_overview_agerating2(inputs)
	if (locale === "no") return no_offerdetail_overview_agerating2(inputs)
	if (locale === "pl") return pl_offerdetail_overview_agerating2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_overview_agerating2(inputs)
	if (locale === "pt") return pt_offerdetail_overview_agerating2(inputs)
	if (locale === "ro") return ro_offerdetail_overview_agerating2(inputs)
	if (locale === "fi") return fi_offerdetail_overview_agerating2(inputs)
	if (locale === "sv") return sv_offerdetail_overview_agerating2(inputs)
	if (locale === "vi") return vi_offerdetail_overview_agerating2(inputs)
	if (locale === "tr") return tr_offerdetail_overview_agerating2(inputs)
	if (locale === "cs") return cs_offerdetail_overview_agerating2(inputs)
	if (locale === "bg") return bg_offerdetail_overview_agerating2(inputs)
	if (locale === "ru") return ru_offerdetail_overview_agerating2(inputs)
	if (locale === "uk") return uk_offerdetail_overview_agerating2(inputs)
	if (locale === "ar") return ar_offerdetail_overview_agerating2(inputs)
	if (locale === "hi") return hi_offerdetail_overview_agerating2(inputs)
	if (locale === "th") return th_offerdetail_overview_agerating2(inputs)
	if (locale === "ja") return ja_offerdetail_overview_agerating2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_overview_agerating2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_overview_agerating2(inputs)
	return ko_offerdetail_overview_agerating2(inputs)
});
export { offerdetail_overview_agerating2 as "offerDetail.overview.ageRating" }